import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import HomePage from './pages/HomePage';
import DashboardHomePage from './pages/DashboardHomePage';
import LoginPage from './pages/LoginPage';
import FeaturesPage from './pages/FeaturesPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import TermsPage from './pages/TermsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import Layout from './components/Layout';
import PWAInstallPrompt from "./components/PWAInstallPrompt";
import { ToastContainer } from 'react-toastify';

function App() {
  const location = useLocation();

  return (

      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Layout><HomePage /></Layout>} />
          <Route path="/features" element={<Layout><FeaturesPage /></Layout>} />
          <Route path="/about" element={<Layout><AboutPage /></Layout>} />
          <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
          <Route path="/login" element={<Layout><LoginPage /></Layout>} />
          <Route path="/terms" element={<Layout><TermsPage /></Layout>} />
          <Route path="/privacy" element={<Layout><PrivacyPolicyPage /></Layout>} />
          <Route path="/dashboard" element={<DashboardHomePage />} />
        </Routes>
        <PWAInstallPrompt />
        <ToastContainer position="top-center" />
      </AnimatePresence>
      

  );
}

export default App;
